import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import "../styles/CheckoutPage.css";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
// import CheckoutItems from "../components/CheckoutItems";
import CheckoutSummary from "../components/CheckoutSummary";
import PersonalInfo from "../components/PersonalInfo";
import GstinSection from "../components/GstinSection";
import ShippingAddressSection from "../components/ShippingAddressSection";
import CheckoutFooterInfo from "../components/CheckoutFooterInfo";
import AddressModal from "../components/AddressModal";
import Footer from "../../../../components/Footer/Footer";
import { fetchCheckout } from "../redux/checkoutSlice";
import { useCheckout } from "../hooks/useCheckout";
import { createAddress, getAddress } from "../../../Account/address/redux/addressSlice";
import { fetchUserProfile } from "../../../Account/profile/redux/profileSlice";
import EditAddressModel from "../components/EditAddressModel";
import CartFooter from "../../../../components/Footer/CartFooter";
import CartHeader from "../../../../components/Navbars/CartHeader";

const CheckoutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [gstinEnabled, setGstinEnabled] = useState(false);
  const [gstinData, setGstinData] = useState({
    registrationNumber: "",
    companyAddress: "",
  });

  const [defaultAddr, setDefultAddr] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const gstInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { checkoutData } = useSelector((state) => state.checkout);
  const { data: addressdata = [] } = useSelector((state) => state.address);
  const { data: profileData } = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(fetchCheckout());
    dispatch(getAddress());
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const { handlePlaceOrder } = useCheckout(
    defaultAddr,
    gstinEnabled,
    gstinData,
    checkoutData,
    navigate
  );

  // CONTINUE BUTTON HANDLER
    const handleContinueClick = async () => {
    if (loading) return;
    const gstNumber = gstinData?.registrationNumber?.trim();
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (gstinEnabled) {
      if (!gstNumber) {
        toast.error("Please input GSTIN Registration No");
        focusGST();
        return;
      }

      if (!gstRegex.test(gstNumber)) {
        toast.error("Please input GSTIN Registration No");
        focusGST();
        return;
      }
    }

    // helper function
    function focusGST() {
      if (gstInputRef.current) {
        gstInputRef.current.focus();
        gstInputRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }

    if (!defaultAddr) {
      toast.error("Please select shipping address");
      return;
    }

    setLoading(true);

    try {
      await handlePlaceOrder();
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const [showEditAddressModal, setShowEditAddressModal] = useState(false);
  const [editAddressData, setEditAddressData] = useState(null);

  return (
    <>
      <CartHeader/>

      <Toaster position="top-right" />

      {/* <Breadcrumbs
        paths={[
          { label: "Cart", to: "/cart" },
          { label: "Checkout", to: "" },
        ]}
      /> */}
 
      {/* <div className="root-title-chk containerbox-padding">
        <h2 className="title_chk">Checkout</h2>
       </div> */}

      <div className="checkout-container_chk checkout-containerbox">
        {/* <CheckoutItems checkoutData={checkoutData} /> */}
            <div className="checkout-right_ck"> 
         {/* 
            <PersonalInfo profileData={profileData} /> */}

            <ShippingAddressSection
              addressdata={addressdata}
              selectedAddressId={selectedAddressId}
              setSelectedAddressId={setSelectedAddressId}
              setDefultAddr={setDefultAddr}
              setShowAddAddressModal={setShowAddAddressModal}
              setEditAddressData={setEditAddressData}
              setShowEditAddressModal={setShowEditAddressModal}
            />
            
            </div>   

        {checkoutData?.data?.items?.length > 0 && (
          <div className="checkout-left_ck">
              <div className="checkbox-section"> 

            <CheckoutSummary checkoutData={checkoutData} items={checkoutData?.data?.items || []} />

            {/* <GstinSection
              gstinEnabled={gstinEnabled}
              setGstinEnabled={setGstinEnabled}
              gstinData={gstinData}
              setGstinData={setGstinData}
              ref={gstInputRef}
            /> */}

            <div className="root_track">
              <button
                onClick={handleContinueClick}
                className="payment-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="btn-spinner"></span>
                    Processing...
                  </>
                ) : (
                  "Continue to Payment"
                )}
              </button>
            </div>
 
            <GstinSection
              gstinEnabled={gstinEnabled}
              setGstinEnabled={setGstinEnabled}
              gstinData={gstinData}
              setGstinData={setGstinData}
              ref={gstInputRef}
            />

            <CheckoutFooterInfo />
         
         
              </div>
          </div>
        )}
      </div>

      {showAddAddressModal && (
        <AddressModal
          setShowAddAddressModal={setShowAddAddressModal}
          createAddress={createAddress}
          getAddress={getAddress}
        />
      )}

      {showEditAddressModal && editAddressData && (
        <EditAddressModel
          editAddressData={editAddressData}
          setEditAddressData={setEditAddressData}
          setShowEditAddressModal={setShowEditAddressModal}
        />
      )}

      {/* <Footer /> */}
      <CartFooter/>
    </>
  );
};
export default CheckoutPage;